import React, { useMemo, useState, useEffect, useCallback } from "react";
import {
  useReactTable,
  getCoreRowModel,
  getSortedRowModel,
  getFilteredRowModel,
  getPaginationRowModel,
  flexRender,
} from "@tanstack/react-table";
import { ChevronLeft, ChevronRight } from "lucide-react";
import Dropdown from "react-bootstrap/Dropdown";
import { Columns } from "../../Column.js";
import MOCK_DATA from "../../MOCK_DATA.json";
import "../List.css";
import down from "../../../../assets/Vehicles/chevron_down.png";
import search from "../../../../assets/Vehicles/search.png";
import { useNavigate } from "react-router-dom";
import editIcon from "../../../../assets/svg/edit.svg";
import delIcon from "../../../../assets/svg/delete.svg";
import ReactPaginate from "react-paginate";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import lar from "../../../../assets/svg/lar.svg";
import rar from "../../../../assets/svg/rar.svg";
import {getCommonTableListApi} from "./table-list-api.js";
import DeleteModal from "../../../common/delete-modal.js";

export const FinancialHistoryTableList = ({tableList}) => {
    const navigate = useNavigate();

    const columns = [
      {
         header: "Code",
         accessorKey: "code",
         cell: (info) => (
           <div
             style={{
               whiteSpace: "nowrap",
               overflow: "hidden",
               textOverflow: "ellipsis",
               maxWidth: "150px",
             }}
           >
             {info.getValue()}
           </div>
         ),
       },
       {
         header: "Vendor Name",
         accessorKey: "vendor_name",
         cell: (info) => (
           <div
             style={{
               whiteSpace: "nowrap",
               overflow: "hidden",
               textOverflow: "ellipsis",
               maxWidth: "150px",
             }}
           >
             {info.getValue()}
           </div>
         ),
       },
       
       {
         header: "Payment Amount",
         accessorKey: "payment_amount",
         cell: (info) => (
           <div
             style={{
               whiteSpace: "nowrap",
               overflow: "hidden",
               textOverflow: "ellipsis",
               maxWidth: "160px",
             }}
           >
             {info.getValue()}
           </div>
         ),
       },
   
       {
         header: "Amount Per Month",
         accessorKey: "amount_per_month",
         cell: (info) => (
           <div
             style={{
               whiteSpace: "nowrap",
               overflow: "hidden",
               textOverflow: "ellipsis",
               maxWidth: "160px",
             }}
           >
             {info.getValue()}
           </div>
         ),
       },
      
       {
         header: "Due Date",
         accessorKey: "due_date",
         cell: (info) => (
           <div
             style={{
               whiteSpace: "nowrap",
               overflow: "hidden",
               textOverflow: "ellipsis",
               maxWidth: "160px",
             }}
           >
             {info.getValue()}
           </div>
         ),
       },
       {
         header: "Balance",
         accessorKey: "balance",
         cell: (info) => (
           <div
             style={{
               whiteSpace: "nowrap",
               overflow: "hidden",
               textOverflow: "ellipsis",
               minWidth: "160px",
             }}
           >
             {info.getValue()}
           </div>
         ),
       },
   
       {
         header: "Time(Months)",
         accessorKey: "month",
         cell: (info) => {
           console.log(info);
           return (
             <div
               className="hover-action-cell"
               style={{
                 whiteSpace: "nowrap",
                 overflow: "hidden",
                 textOverflow: "ellipsis",
                 minWidth: "150px",
               }}
             >
               <span>{info.getValue()}</span>
               
             </div>
           );
         },
       },
     ];
  const data = useMemo(() =>  [], []);
  // Global filter (search)
  const [globalFilter, setGlobalFilter] = useState("");
  

   
              

  const table = useReactTable({
    data:tableList??[],
    columns,
    state: {
      globalFilter,
    },
    onGlobalFilterChange: setGlobalFilter,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
  });

  const { pageIndex, pageSize } = table.getState().pagination;
  const pageOptions = table.getPageOptions();

  

  
  return (
    <>    
                     
    <div className="p-3">
      <div className="d-flex flex-wrap mb-3 align-items-center justify-content-between">
        <p className="m-0">Details table</p>
        <div className="search-wrapper d-flex align-items-center gap-2 bg-white rounded-3 px-3 py-2">
          <img src={search} alt="search" />
          <input
            type="text"
            placeholder="Search"
            className="border-0 outline-0 rounded-3"
            value={globalFilter || ""}
            onChange={(e) => setGlobalFilter(e.target.value)}
          />
        </div>
      </div>
      <div className="table-container rounded-4 overflow-x-auto">
        <table>
          <thead>
            {table.getHeaderGroups().map((headerGroup) => (
              <tr key={headerGroup.id}>
                {headerGroup.headers.map((header) => (
                  <th
                    key={header.id}
                    className="px-3 py-2"
                    onClick={header.column.getToggleSortingHandler()}
                  >
                    {flexRender(
                      header.column.columnDef.header,
                      header.getContext()
                    )}
                    {header.column.getIsSorted() === "asc" && " asc"}
                    {header.column.getIsSorted() === "desc" && " des"}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody>
            {table.getRowModel().rows.map((row) => (
              <tr key={row.id}>
                {row.getVisibleCells().map((cell) => (
                  <td key={cell.id} className="px-3 py-2">
                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div className="py-3 d-flex justify-content-between align-items-center flex-wrap gap-3">
       <Dropdown>
                 <span className="pagination-color">Records per page: &nbsp;</span>
                 <Dropdown.Toggle
                   id="dropdown-basic"
                   className="bg-transparent pagination-color  border-0 custom-dropdown-toggle p-0"
                 >
                   <span className="bg-white no-of-rows rounded-3 px-2 py-2">
                     {pageSize} <img src={down} alt="" />
                   </span>
                 </Dropdown.Toggle>
                 <Dropdown.Menu
                   className="my-2"
                   style={{ minWidth: "unset", width: "30%" }}
                 >
                   {[10, 25, 50, 75, 100].map((size) => (
                     <Dropdown.Item
                       key={size}
                       onClick={() => table.setPageSize(size)}
                       active={pageSize === size}
                       className="text-center"
                     >
                       {size}
                     </Dropdown.Item>
                   ))}
                 </Dropdown.Menu>
               </Dropdown>

        <div className="d-flex align-items-center gap-2">
            <button
                      className="pagination-border bg-white rounded-circle p-2"
                      onClick={() => table.previousPage()}
                      disabled={!table.getCanPreviousPage()}
                    >
                      <ChevronLeft className="pagination-color" />
                    </button>
          
                    {pageOptions.length > 0 &&
                      (() => {
                        const totalPages = pageOptions.length;
                        const maxVisible = 3;
                        let start = Math.max(0, pageIndex - Math.floor(maxVisible / 2));
                        let end = start + maxVisible;
                        if (end > totalPages) {
                          end = totalPages;
                          start = Math.max(0, totalPages - maxVisible);
                        }
                        const visiblePages = pageOptions.slice(start, end);
                        return (
                          <>
                            {visiblePages.map((pageNum) => (
                              <button
                                key={pageNum}
                                className={`pagination-border rounded-circle p-2 px-3 ${
                                  pageIndex === pageNum
                                    ? "dark-purple-btn"
                                    : "bg-white pagination-color"
                                }`}
                                onClick={() => table.setPageIndex(pageNum)}
                              >
                                {pageNum + 1}
                              </button>
                            ))}
                            {visiblePages[visiblePages.length - 1] < totalPages - 1 && (
                              <>
                                <span className="mx-2 pagination-color">...</span>
                                <button
                                  className={`pagination-border rounded-circle p-2 px-3 ${
                                    pageIndex === totalPages - 1
                                      ? "dark-purple-btn"
                                      : "bg-white pagination-color"
                                  }`}
                                  onClick={() => table.setPageIndex(totalPages - 1)}
                                >
                                  {totalPages}
                                </button>
                              </>
                            )}
                          </>
                        );
                      })()}
          
                    <button
                      className="pagination-border bg-white rounded-circle p-2"
                      onClick={() => table.nextPage()}
                      disabled={!table.getCanNextPage()}
                    >
                      <ChevronRight className="pagination-color" />
                    </button>
        </div>
      </div>
    </div>
     </>
  );
};
